export enum NOTIFICATION_STATUS {
  ACTIVE = 1,
  PROCESSING = 2,
  EXPIRED = 3,
  ERROR = 4
}
